<template>
	<div>
		<commonHeader />
		<div v-if="nowWidth > 784">
			<div class="about_1">
				<v-img src="/image/about2.png" class="px-pc">
					<div class="about_1_text">
						About Us
					</div>
					<v-layout>
						<v-layout class="tab-css-2">
							<v-flex v-for="(tab, i) in $store.state.tabList" :key="i" class="pr-8" style="flex: 1; max-width: 20%;">
								<v-flex xs12>
									<v-divider dark class="main-hr-1 mb-4"></v-divider>
								</v-flex>
								<div>
									<div class="number mr-2">0{{ i + 1 }}</div>
									<div class="Title" @click="titleGoto(tab.link)">
										{{ tab.title }}
									</div>
								</div>
							</v-flex>
						</v-layout>
					</v-layout>
				</v-img>
			</div>
			<div class="px-pc">
				<div class="divider_1_layout">
					<hr class="divider_1" />
				</div>
				<v-layout justify-center>
					<div class="about_content_1">
						<span class="s">
							세마인베스트먼트㈜
						</span>
						는 과학기술인 회원의 운용 자산으로 조성된 과학기술인공제회가 100% 출자하여 설립한 창업투자회사(Venture Capital)로서<br />
						우수한 기술력을 보유한 국내 스타트업에 투자하는 벤처 펀드 및 성장가능성이 높은 기업에 투자하는 사모 펀드(PEF)를 운용하고
						있습니다.
						<br />
						<br />
						과학기술인공제회(SEMA : Korea Scientists & Engineers Mutual-aid Association)는 과학기술인의 노후 생활 안정과 복지 증진을 위하여
						2003년 과학기술정보통신부의
						<br />
						출연으로 설립되었으며, 2025년 기준 총 13만명의 회원 보유 및 총자산 17조원으로 최근 연간 1조원 이상 자산이 증대되는 등 업계에서
						괄목할 만한 성장을 하고 있습니다.
						<br />
						<br />
						세마인베스트먼트㈜는 과학기술인공제회의 네트워크와 VC 및 PE업계에서 다양한 투자 경험을 보유한 인력을 바탕으로<br />
						우수한 기술력과 사업모델을 보유한 기업의 사업화 및 성장을 지원하고 있으며, 대한민국의 과학기술 강국의 기반을 다지는데 기여하고
						있습니다.
					</div>
				</v-layout>
				<div class="divider_2_layout mb-2">
					<hr class="divider_1" />
				</div>
			</div>

			<v-timeline class="about_timeline">
				<v-timeline-item color="aboutColor1" small icon="04" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2026</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							세마밸류업벤처투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="06" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2024</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							세마소부장스케일업투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="05" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2024</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							한국투자세마인베로보틱스사모투자 합자회사 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="08" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2023</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							스케일업 팁스(투자형R&D) 운영사 선정
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="11" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2022</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							세마공공기술사업화투자조합2호 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="07" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2021</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							세마공공기술사업화투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="03" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2021</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							세마인베스트먼트(주) 사명 변경
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="12" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2017</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							Translink글로벌파트너쉽청년창업투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="08" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2017</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							SETI고급기술창업초기투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="12" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2016</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							Translink글로벌파트너쉽투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="12" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2015</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							창업투자회사 등록
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="08" fill-dot right class="about_timeline_bottom">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold aboutColor1--text`">2015</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							세마트랜스링크인베스트먼트(주) 설립
						</h2>
					</div>
				</v-timeline-item>
			</v-timeline>
			<div class="about_2">
				<v-img src="/image/about3.png" contain></v-img>
			</div>
		</div>
		<div v-else>
			<div class="m_about_1">
				<v-img width="100%" src="/image/m_about1.png" class="pl-6">
					<div class="m_about_1_text">
						About Us
					</div>
				</v-img>
			</div>
			<v-layout class="m_divider_1_layout">
				<hr class="m_divider_4" />
				<div class="m_about_content_1">
					<div class="set">
						<span class="s">
							세마인베스트먼트㈜
						</span>
						는 국내 주요 연기금 중 하나인 과학기술인공제회가 100% 출자하여 설립한 창업투자회사(Venture Capital)로서 우수한 기술력을 보유한
						국내 스타트업에 투자하는 벤처 펀드 및 성장가능성이 높은 기업에 투자하는 사모 펀드(PEF)를 운용하고 있습니다.
						<br />
						<br />
						과학기술인공제회(SEMA : Korea Scientists & Engineers Mutual-aid Association)는 과학기술인의 노후 생활 안정과 복지 증진을 위하여
						2003년 과학기술정보통신부의 출연으로 설립되었으며, 2025년 기준 총 13만명의 회원 보유 및 총자산 17조원으로 최근 연간 1조원 이상의
						자산이 증대되는 등 업계에서 괄목할 만한 성장을 하고 있습니다.
						<br />
						<br />
						세마인베스트먼트㈜는 과학기술인공제회의 네트워크와 VC 및 PE업계에서 다양한 투자 경험을 보유한 인력을 바탕으로 우수한 기술력과
						사업모델을 보유한 기업의 사업화 및 성장을 지원하고 있으며 대한민국의 과학기술 강국의 기반을 다지는데 기여하고 있습니다.
					</div>
					<div class="mt-10">
						<v-img width="100%" src="/image/m_about2.png"></v-img>
					</div>
				</div>
			</v-layout>
			<v-timeline class="m_about_timeline">
				<v-timeline-item color="aboutColor1" small icon="04" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2026</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text`">
							세마밸류업벤처투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="06" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2024</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text`">
							세마소부장스케일업투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="05" fill-dot right>
					<template v-slot:opposite>
						<div>
							<span :class="`headline font-weight-bold m_aboutColor1--text`">2024</span>
						</div>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text`">
							한국투자세마인베로보틱스사모투자 합자회사 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="08" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2023</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text`">
							스케일업 팁스(투자형R&D) 운영사 선정
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="11" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2022</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text`">
							세마공공기술사업화투자조합2호 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="07" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2021</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text`">
							세마공공기술사업화투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="03" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2021</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text`">
							세마인베스트먼트(주) 사명 변경
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="12" fill-dot right class="">
					<template v-slot:opposite>
						<div>
							<span :class="`headline font-weight-bold m_aboutColor1--text`">2017</span>
						</div>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							Translink글로벌파트너쉽청년창업투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="08" fill-dot right>
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2017</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							SETI고급기술창업초기투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="12" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2016</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text`">
							Translink글로벌파트너쉽투자조합 결성
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="12" fill-dot right class="">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2015</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							창업투자회사 등록
						</h2>
					</div>
				</v-timeline-item>
				<v-timeline-item color="aboutColor1" small icon="08" fill-dot right class="about_timeline_bottom">
					<template v-slot:opposite>
						<span :class="`headline font-weight-bold m_aboutColor1--text`">2015</span>
					</template>
					<div class="py-4">
						<h2 :class="`headline font-weight-light mb-4 black--text text-left`">
							세마트랜스링크인베스트먼트(주) 설립
						</h2>
					</div>
				</v-timeline-item>
			</v-timeline>
		</div>
		<commonFooter />
	</div>
</template>
<script>
import { commonHeader, commonFooter } from '@/components/index'
export default {
	components: {
		commonHeader,
		commonFooter,
	},
	data() {
		return {
			screenWidth: window.innerWidth,
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		titleGoto(link) {
			this.$router.push({ name: link })
		},
	},
}
</script>
<style lang="scss">
.width-264 {
	width: 264px;
}
</style>
